export const patterData = [
  {
    id: '1',
    title: '医疗机构',
    patter: [
      {
        icon:
          'https://img.alicdn.com/tfs/TB1VdrlykT2gK0jSZFkXXcIQFXa-310-310.png',
        title: '浙江省卫健委',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1ucThybr1gK0jSZFDXXb9yVXa-310-310.png',
        title: '余杭卫健委',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1AW_fyfb2gK0jSZK9XXaEgFXa-310-310.png',
        title: '浙江大学医学院附属第二医院',
        width: 10,
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1qTThyoT1gK0jSZFhXXaAtVXa-310-310.png',
        title: '建德医院',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1Y72oylr0gK0jSZFnXXbRRXXa-310-310.png',
        title: '重庆妇保院',
      },
    ],
  },
  {
    id: '2',
    title: '集团生态',
    patter: [
      {
        icon:
          'https://img.alicdn.com/tfs/TB1jXTkybH1gK0jSZFwXXc7aXXa-378-378.png',
        title: '阿里健康',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1fXjhykP2gK0jSZPxXXacQpXa-378-378.png',
        title: '阿里云',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1uKYfyXT7gK0jSZFpXXaTkpXa-378-378.png',
        title: '蚂蚁金服',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1kmDfyhD1gK0jSZFsXXbldVXa-378-378.png',
        title: '钉钉',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1__DhyoT1gK0jSZFhXXaAtVXa-378-378.png',
        title: '熙牛 ',
      },
    ],
  },
];
